import { api as authApi } from './auto-generated/auth'

authApi.enhanceEndpoints({
  addTagTypes: ['MeUser'],
  endpoints: {
    authUpdateProfile: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        patchResult = dispatch(
          authApi.util.updateQueryData('authWhoami', {}, (draftAuth) => {
            draftAuth.full_name = args.updateProfileRequest.full_name
            draftAuth.image = args.updateProfileRequest.image
            // dispatch(setUser(current(draftAuth)))
          }),
        )
        try {
          await queryFulfilled
        } catch {
          patchResult?.undo()
        }
      },
    },
    authWhoami: {
      providesTags: ['MeUser'],
    },
  },
})

export { authApi }
